// extracted by mini-css-extract-plugin
module.exports = {"typeahead":"TagsTypeahead_typeahead__Jfkbu","item":"TagsTypeahead_item__BFvUs","link":"TagsTypeahead_link__D25hq"};